import script from "./Snappy-CaseStudies.vue?vue&type=script&setup=true&lang=js"
export * from "./Snappy-CaseStudies.vue?vue&type=script&setup=true&lang=js"

import "./Snappy-CaseStudies.vue?vue&type=style&index=0&id=49c280b2&lang=css"
import "./Snappy-CaseStudies.vue?vue&type=style&index=1&id=49c280b2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c280b2"]])

export default __exports__